import 'fontsource-roboto'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import URI from 'urijs'

import Loading from '../components/loading'
import config from '../config'
import CompanyListHandlerBtnBar from '../containers/company/CompanyListHandlerBtnBar'
import CompanyListTable from '../containers/company/CompanyListTable'
import HorizontalGridDivider from '../containers/horizontalGridDivider'
import ListTitleBar from '../containers/listTitleBar'
import SideMenu from '../containers/sideMenu'
import StyledMain from '../containers/styledMain'
import TopBar from '../containers/topBar'
import VerticalGridDivder from '../containers/verticalGridDivider'
import { Pagination } from '../interfaces/common'
import { CompanyListInterface } from '../interfaces/company'
import {
  getCompanyListRequest,
  getCompanyStatusStatisticsRequest
} from '../redux/company/actions'
import {
  getCompanyList,
  getCompanyStatistics,
  getIsFetchingCompanyList
} from '../redux/company/selectors'
import { getQuery } from '../utils/common'

const CompanyList = () => {
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const history = useHistory()
  const query = getQuery(search)
  const {
    page = 1,
    limit = config.api.defaultQuery.limit,
    sortBy = config.api.defaultQuery.sortBy,
    sortDirection = config.api.defaultQuery.sortDirection,
    q
  } = query

  const companyStatistics = useSelector(getCompanyStatistics) as null | {
    [key: string]: number
  }

  const companyList = useSelector(getCompanyList) as Pagination<
    CompanyListInterface
  >
  const isFetchingCompanyList = useSelector(getIsFetchingCompanyList)

  useEffect(() => {
    dispatch(getCompanyStatusStatisticsRequest())
  }, [])

  useEffect(() => {
    dispatch(
      getCompanyListRequest({
        page,
        limit,
        sortBy,
        sortDirection,
        q
      })
    )
  }, [search])

  const handleChangePage = (_event: unknown, newPage: number) => {
    history.push(
      pathname +
        '?' +
        URI.buildQuery({
          page: newPage + 1,
          limit,
          sortBy,
          sortDirection,
          q
        })
    )
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    history.push(
      pathname +
        '?' +
        URI.buildQuery({
          page,
          limit: event.target.value,
          sortBy,
          sortDirection,
          q
        })
    )
  }

  console.log('companyStatistics :::::::::::::', companyStatistics)
  return (
    <HorizontalGridDivider>
      <SideMenu />
      <VerticalGridDivder>
        <TopBar />
        <StyledMain>
          <ListTitleBar title={'Profile List'} statistics={companyStatistics} />
          <CompanyListHandlerBtnBar />
          {isFetchingCompanyList ? (
            <Loading />
          ) : (
            <CompanyListTable
              companyList={companyList}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
        </StyledMain>
      </VerticalGridDivder>
    </HorizontalGridDivider>
  )
}

export default CompanyList
